export default __webpack_public_path__ + "static/media/icons.7eefe04d.eot";